import _ from 'lodash';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import moment from 'moment';
import { mapGetters } from 'vuex';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportExcelTemplate';

let CD;

function convertToFull(str) {
    return str.replace(/[!-~]/g, (fullwidthChar) => String.fromCharCode(fullwidthChar.charCodeAt(0) + 0xfee0));
}

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
    },
    methods: {
        onExportAnnualDeclareExcel() {
            const wb = XLSX_STYLE.utils.book_new();
            const ws = this.getAnnualDeclareSheet();
            XLSX_STYLE.utils.book_append_sheet(wb, ws, this.companyInfo.bsn);
            XLSX_STYLE.writeFile(wb, `${this.year}年度所得扣繳申報.xlsx`);
        },
        getServiceDateRange(details) {
            const DATE = _.chain(details)
                .map((o) => o.paY_DAT)
                .sort()
                .value();

            const FIRST_MONTH = moment(_.first(DATE)).format('MM');
            const LAST_MONTH = moment(_.last(DATE)).format('MM');

            return `${this.year - 1911}${FIRST_MONTH}${this.year - 1911}${LAST_MONTH}`;
        },
        getAnnualDeclareSheet() {
            const rows = this.getAnnualDeclareDataRows();
            const sheet = { ...ExportExcelTemplate };
            XLSX_STYLE.utils.sheet_add_aoa(sheet, rows, { origin: 'A11' });

            const widthSettings = [
                20,
                15,
                25,
                15,
                15, // 5
                15,
                15,
                30,
                30,
                30, // 10
                25, // 11
                25, // -
                25, // -
                15, // 12
                15, // 13
                15, // 14
                15, // 15
                35, // 16
                15, // 17
                25, // 18
                25, // -
                25, // -
                15, // -
                15, // -
                15, // 19
                15, // 20
                15,
                25,
                25,
                15,
                30, // 25
                15, // 26
            ];
            // 設定全部欄寬 (由bodyHeader定義，預設 15)
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));
            sheet['!rows'] = [{ hpx: 30 }];

            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    // 'B13' => COL: 'B', ROW: '13'
                    const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
                    // const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
                    const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));

                    // console.log(COL, ROW);

                    // 每一格
                    sheet[key].s = {
                        alignment: {
                            horizontal: 'left',
                            vertical: 'bottom',
                        },
                    };
                    if (ROW > 1) {
                        sheet[key].s.border = {
                            bottom: { style: 'thin', color: 'FFFFFFFF' },
                            top: { style: 'thin', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                        };
                    }

                    if (key === 'A1') {
                        sheet[key].s.alignment.horizontal = 'center';
                        sheet[key].s.alignment.vertical = 'center';

                        sheet[key].s.font = {
                            color: { rgb: 'ff0000' },
                            bold: true,
                            sz: 13,
                        };
                    }

                    if (ROW === 2) {
                        sheet[key].s.alignment.horizontal = 'center';
                        sheet[key].s.fill = { fgColor: { rgb: 'b6d7a8' } };
                    }

                    const HIGHLIGHT_LIST = ['K5', 'K7', 'K9', 'T3', 'T5', 'T7', 'T9'];
                    if (ROW >= 3 && ROW <= 10) {
                        if (HIGHLIGHT_LIST.includes(key)) {
                            sheet[key].s.fill = { fgColor: { rgb: 'ccdaf5' } };
                            sheet[key].s.alignment.horizontal = 'center';
                        } else sheet[key].s.fill = { fgColor: { rgb: 'd9d9d9' } };
                    }
                }
            });

            return sheet;
        },
        getAnnualDeclareDataRows() {
            const rows = [];

            this.datas.forEach((item, i) => {
                // console.log(item);

                rows.push([
                    '', //
                    `${i + 1}`.padStart(8, '0'),
                    this.companyInfo.bsn,
                    '',
                    item.serviceType > 0 ? this.getIncomeTypeTxt(item.serviceType) : '',
                    item.bsn,
                    item.bsN_TYP === 1 ? 0 : 1,
                    item.amount,
                    item.taX_AMT,
                    item.incomeNet,
                    this.getServiceTypeNumberByItem(item),
                    '',
                    '',
                    '',
                    '',
                    this.year - 1911,
                    item.nam,
                    convertToFull(`${item.cty}${item.adr}`),
                    this.getServiceDateRange(item.payments),
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    1,
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                ]);
            });

            return rows;
        },

        getServiceTypeNumberByItem(item) {
            return item.serviceSubType ? item.serviceSubType : '';
        },

        // 匯出ahoo資料
        onExportSelected() {
            const wb = MyXLSX2.createBook();
            const details = _.chain(this.datas)
                .filter((o) => o.checked || o.isIndeterminate)
                .map((o) => ({
                    ...o,
                    amount: _.sumBy(o.payments, 'amount'),
                    taX_AMT: _.sumBy(o.payments, 'taX_AMT'),
                    incomeNet: _.sumBy(o.payments, 'incomeNet'),
                    geN2_AMT: _.sumBy(o.payments, 'geN2_AMT'),
                }))
                .value();

            const target = details.length === 0 ? this.datas : details;
            const AggregateSheet = this.onExportAggregate(target);
            const paymentsDetailSheet = this.onExportPaymentsDetail(target);
            const serviceFeeSheetDetailSheet = this.onExportServiceFeeStatementDetail(target);

            MyXLSX2.bookAppendSheet(wb, AggregateSheet, '彙總');
            MyXLSX2.bookAppendSheet(wb, paymentsDetailSheet, '請款單');
            MyXLSX2.bookAppendSheet(wb, serviceFeeSheetDetailSheet, '勞報單');
            MyXLSX2.download(wb, `${this.year}年度扣繳申報`);
        },
        onExportAggregate(details) {
            const title = `${this.year}年度扣繳申報 - 彙總`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '所得人姓名', align: 'left' },
                { text: '筆數', width: 10, align: 'center' },
                { text: '身分證/統編', align: 'center' },
                { text: '地址', align: 'left', width: 30 },
                { text: '所得類型', align: 'left' },
                { text: '業別代號', align: 'left', width: 20 },
                { text: '業務執行所得', align: 'right', number: true },
                { text: '稅款', align: 'right', number: true },
                { text: '所得淨額', align: 'right', number: true },
                { text: '代扣二代健保', align: 'right', number: true },
                { text: '健保所得代號', align: 'center' },
            ];
            // 內容資料
            const bodyRows = [];
            details.forEach((item, i) => {
                const row = [
                    i + 1,
                    item.nam,
                    item.payments.length,
                    item.bsn,
                    `${item.cty}${item.adr}`,
                    this.getServiceTypeDescribe(item.serviceType),
                    this.getServiceTypeTxt(item.serviceSubType),
                    item.amount,
                    item.taX_AMT,
                    item.incomeNet,
                    item.geN2_AMT,
                    this.getServiceTypeHealthInsuranceCode(item.serviceType),
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, 'amount');
            const totalTax = _.sumBy(details, 'taX_AMT');
            const totalIncomeNet = _.sumBy(details, 'incomeNet');
            const totalGen2 = _.sumBy(details, 'geN2_AMT');
            bodyRows.push(['', '總計', '', '', '', '', '', totalAmt, totalTax, totalIncomeNet, totalGen2, '']);

            // 表頭資訊
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        onExportPaymentsDetail(aggregateData) {
            const details = _.flatMap(aggregateData, 'payments');
            const title = `${this.year}年度扣繳申報 - 請款單`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '對象', align: 'left' },
                { text: '請款單號', align: 'center' },
                { text: '所得類型', align: 'left' },
                { text: '業別代號', align: 'left', width: 20 },
                { text: '請款單日期', align: 'center', number: true },
                { text: '請款摘要', width: 35, align: 'left' },
                { text: '業務執行所得', align: 'right', number: true },
                { text: '稅款', align: 'right', number: true },
                { text: '所得淨額', align: 'right', number: true },
                { text: '代扣二代健保', align: 'right', number: true },
                { text: '給付日期', align: 'center', number: true },
            ];
            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.nam,
                    item.payoo,
                    this.getServiceTypeDescribe(item.serviceType),
                    this.getServiceTypeTxt(item.serviceSubType),
                    moment(item.dat).format('YYYY-MM-DD'),
                    item.paymentName,
                    item.amount,
                    item.taX_AMT,
                    item.incomeNet,
                    item.geN2_AMT,
                    moment(item.paY_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 表頭資訊
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        onExportServiceFeeStatementDetail(aggregateData) {
            const details = _.flatMap(aggregateData, 'serviceFeeStatementItems');
            const title = `${this.year}年度扣繳申報 - 勞報單`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '對象', align: 'left' },
                { text: '勞務單號', align: 'center' },
                { text: '所得類型', align: 'left' },
                { text: '業別代號', align: 'left', width: 20 },
                { text: '來源請款單號', width: 20, align: 'center' },
                { text: '勞務報酬', align: 'right', number: true },
                {
                    text: '稅款',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '所得淨額',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '代扣二代健保',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                { text: '給付日期', align: 'center', number: true },
            ];
            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.nam,
                    item.systemNo,
                    this.getServiceTypeDescribe(item.incomeType),
                    this.getServiceTypeTxt(item.serviceType),
                    item.payoo,
                    item.amt,
                    item.taxAmt,
                    item.amt - item.taxAmt,
                    item.gen2Amt,
                    moment(item.paY_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });

            // 表頭資訊
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        onExportSingle(scopeRow) {
            const name = scopeRow.nam;
            const wb = MyXLSX2.createBook();
            const paymentSheet = this.createSinglePaymentsSheet(scopeRow, this.year);
            const serviceFeeSheet = this.createSingleServiceFeesSheet(scopeRow, this.year);
            MyXLSX2.bookAppendSheet(wb, paymentSheet, '請款單');
            MyXLSX2.bookAppendSheet(wb, serviceFeeSheet, '勞報單');
            MyXLSX2.download(wb, `${this.year}年度扣繳申報 - ${name}`);
        },
        createSinglePaymentsSheet(data, year) {
            const datas = data.payments;
            const name = data.nam;
            const title = `${year}年度扣繳申報 - ${name} - 請款單`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '請款單號', align: 'center' },
                { text: '請款摘要', width: 80, align: 'left' },
                { text: '所得類型', align: 'left' },
                { text: '業別代號', align: 'left', width: 20 },
                { text: '請款單日期', align: 'center', number: true },
                { text: '請款金額', align: 'right', number: true },
                {
                    text: '稅款',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '所得淨額',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '代扣二代健保',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                { text: '給付日期', align: 'center', number: true },
            ];
            // 內容資料
            const bodyRows = [];
            datas.forEach((item, i) => {
                const row = [
                    i + 1,
                    item.payoo,
                    item.paymentName,
                    this.getServiceTypeDescribe(item.serviceType),
                    this.getServiceTypeTxt(item.serviceSubType),
                    moment(item.dat).format('YYYY-MM-DD'),
                    item.amount,
                    item.taX_AMT,
                    item.incomeNet,
                    item.geN2_AMT,
                    moment(item.paY_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(datas, 'amount');
            const totalTax = _.sumBy(datas, 'taX_AMT');
            const totalIncomeNet = _.sumBy(datas, 'incomeNet');
            const totalGen2 = _.sumBy(datas, 'geN2_AMT');
            bodyRows.push(['', '總計', '', '', '', '', totalAmt, totalTax, totalIncomeNet, totalGen2, '']);

            // 表頭資訊
            const headRows = [
                { label: '查詢區間', value: `${year}年度` },
                { label: '製表日期', value: CD },
                { label: '所得人姓名', value: name },
                { label: '身分證/統編', value: data.bsn },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows, true);
        },
        createSingleServiceFeesSheet(data, year) {
            const datas = data.serviceFeeStatementItems;
            const name = data.nam;
            const title = `${year}年度扣繳申報 - ${name} - 勞報單`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '勞務單號', align: 'center' },
                { text: '勞務摘要', width: 80, align: 'left' },
                { text: '所得類型', align: 'left' },
                { text: '業別代號', align: 'left', width: 20 },
                { text: '來源請款單號', width: 20, align: 'center' },
                { text: '勞務報酬', align: 'right', number: true },
                {
                    text: '稅款',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '所得淨額',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                {
                    text: '代扣二代健保',
                    width: 13,
                    align: 'right',
                    number: true,
                },
                { text: '給付日期', align: 'center', number: true },
            ];
            // 內容資料
            const bodyRows = [];
            datas.forEach((item, i) => {
                const row = [
                    i + 1,
                    item.systemNo,
                    item.nam,
                    this.getServiceTypeDescribe(item.incomeType),
                    this.getServiceTypeTxt(item.serviceType),
                    item.payoo,
                    item.amt,
                    item.taxAmt,
                    item.amt - item.taxAmt,
                    item.gen2Amt,
                    moment(item.paY_DAT).format('YYYY-MM-DD'),
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(datas, 'amt');
            const totalTax = _.sumBy(datas, 'taxAmt');
            const totalIncomeNet = _.sumBy(datas, (o) => o.amt - o.taxAmt);
            const totalGen2 = _.sumBy(datas, 'gen2Amt');
            bodyRows.push(['', '總計', '', '', '', '', totalAmt, totalTax, totalIncomeNet, totalGen2, '']);

            // 表頭資訊
            const headRows = [
                { label: '查詢區間', value: `${year}年度` },
                { label: '製表日期', value: CD },
                { label: '所得人姓名', value: name },
                { label: '身分證/統編', value: data.bsn },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows, true);
        },
    },
};
